/* eslint-disable consistent-return */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */
export const getVisiblePages = (currentPage, totalPages, siblingCount = 1) => {
    const DOTS = "...";
    const totalVisibleItems = siblingCount * 2 + 5;

    if (totalPages <= totalVisibleItems) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages);

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < totalPages - 1;

    const firstPage = 1;
    const lastPage = totalPages;

    if (!showLeftDots && showRightDots) {
        const leftItemCount = totalVisibleItems - 2;
        const leftRange = Array.from({ length: leftItemCount }, (_, i) => i + 1);
        return [...leftRange, DOTS, lastPage];
    }

    if (showLeftDots && !showRightDots) {
        const rightItemCount = totalVisibleItems - 2;
        const start = totalPages - rightItemCount + 1;
        const rightRange = Array.from({ length: rightItemCount }, (_, i) => start + i);
        return [firstPage, DOTS, ...rightRange];
    }

    if (showLeftDots && showRightDots) {
        const middleRange = Array.from(
            { length: siblingCount * 2 + 1 },
            (_, i) => currentPage - siblingCount + i
        );
        return [firstPage, DOTS, ...middleRange, DOTS, lastPage];
    }
};
